export default __webpack_public_path__ + "images/models/73ec712065388835f24783a07966c876.usdz";